export const debounce = <T extends Function>(cb: T, wait = 20) => {
    let timer: ReturnType<typeof setTimeout> = setTimeout(() => '', 1000);
    const callable = (...args: any) => {
        clearTimeout(timer);
        timer = setTimeout(() => cb(...args), wait);
    };
    return callable;
};
